<div class="d-flex flex-col">
    <div class="icon-container">
        <div class="d-flex justify-content-end mb-1" *ngIf="response && showResponse && audioBlobUrl">
            <div class="toolbar py-1 px-2 float-right">
                <img src="./assets/img/play_icon.svg" (click)="play()" class="cursor-pointer" *ngIf="isPlaying" matTooltip="Hear it" />
                <img src="./assets/img/pause_circle.svg" (click)="pause()" class="cursor-pointer" *ngIf="isPaused" matTooltip="Pause" />
                <img src="./assets/img/share_icon.svg" title="Post in LinkedIn" (click)="gotoLinkedin()" class="ml-3 cursor-pointer" />
                <div class="menu-btn ml-3 d-inline-block" [matMenuTriggerFor]="menu">
                    <img src="./assets/img/open_slides_blue_icon.svg" title="Download as" />
                    <span type="button" class="text-primary mx-2">Export</span>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="exportAsPdf()"><img src="./assets/img/pdf_icon.svg" title="Download as PDF" class="mr-3" />Download as PDF</button>
                        <button mat-menu-item [disabled]="true" matTooltip="Coming soon">
                            <img src="./assets/img/open_disabled_icon.svg" title="Open in Slides" class="mr-3" />Open in Google Slides
                        </button>
                    </mat-menu>
                    <img src="./assets/img/down_arrow.svg" title="Download as" />
                </div>
            </div>
        </div>
    </div>
    <div class="row mx-0">
        <ng-container *ngFor="let post of responseList; index as i">
            <div class="col-md-6 col-12">
                <small>Variation {{ i + 1 }}</small>
                <div [innerHTML]="post" id="output-{{ i }}" #output></div>
                <div class="options-container">
                    <button [disabled]="true" class="border-0">
                        <mat-icon [matTooltip]="'Rich text editor (Coming soon...)'" class="list-icon" style="font-size: 1.5rem;color:#aaa">edit</mat-icon>
                    </button>
                    <mat-icon [matMenuTriggerFor]="options" class="list-icon">list</mat-icon>
                    <mat-menu #options="matMenu">
                        <button mat-menu-item (click)="makeTextShorter(i)" [disabled]="true">
                            <mat-icon>short_text</mat-icon>
                            <span>Shorter</span>
                        </button>
                        <button mat-menu-item (click)="makeTextCreative(i)">
                            <mat-icon>highlight</mat-icon>
                            <span>Make it more creative</span>
                        </button>
                    </mat-menu>
                    <mat-icon class="list-icon mx-3" [matMenuTriggerFor]="smileyOptions" title="Add emojis">sentiment_satisfied_alt</mat-icon>
                    <mat-menu #smileyOptions="matMenu">
                        <button mat-menu-item (click)="toggleEmojis('add', i)">
                            <mat-icon>add_circle_outlines</mat-icon>
                            <span>Add emoticons</span>
                        </button>
                        <button mat-menu-item (click)="toggleEmojis('remove', i)">
                            <mat-icon>remove_circle_outline</mat-icon>
                            <span>Remove emoticons</span>
                        </button>
                    </mat-menu>
                    <img src="./assets/img/copy_icon.svg" title="Copy to clipboard" (click)="copyToClipboard(i)" class="ml-1 cursor-pointer" />
                </div>
            </div>
        </ng-container>
    </div>

    <div class="addon-output">
        <div [innerHTML]="responseHotTopics" *ngIf="responseHotTopics && postResponse"></div>
        <div [innerHTML]="responseInsights" *ngIf="responseInsights && postResponse"></div>
        <div [innerHTML]="responseRecentPosts" *ngIf="responseRecentPosts && postResponse"></div>
    </div>
</div>

<audio id="textToSpeech" *ngIf="audioBlobUrl" #txtSpch>
    <source [src]="audioBlobUrl" />
</audio>
